export default __webpack_public_path__ + "static/ZiTgTxsF-3eccc6691f69d32f3d4e01b2d623d229.svg";